import styled from 'styled-components'

export const ExternalLinks = styled.div`
  display: grid;
  width: 100%;

  /* PC版: 3列グリッド */
  @media only screen and (min-width: ${(p) => p.theme.vp + 1}px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }

  /* SP版: 2列グリッド */
  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
`

export const ExternalLink = styled.a<{ imageHeight?: string }>`
  display: flex;
  align-items: center;
  height: 80px;
  padding: 8px;
  background-color: ${(p) => p.theme.BACKGROUND_SURFACE};
  border-radius: 4px;
  border: 1px solid ${(p) => p.theme.BORDER};
  box-sizing: border-box;
  text-decoration: none;
  cursor: pointer;

  /* PC版: 左右に配置 */
  @media only screen and (min-width: ${(p) => p.theme.vp + 1}px) {
    justify-content: space-between;
  }

  /* SP版: 中央寄せ */
  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    justify-content: center;
  }

  img:first-child {
    height: ${(p) => p.imageHeight || '100%'};
    max-width: 80%;
    object-fit: contain;
  }

  img:last-child {
    width: 24px;
    height: 24px;

    /* SP版で矢印アイコンを非表示 */
    @media only screen and (max-width: ${(p) => p.theme.vp}px) {
      display: none;
    }
  }
`
